import graphqlClient from '~/graphql/graphqlClient';

export type RandomInnOpponentsResult = {
  gameSubmode: string;
  innOpponents: any[];
};

export type QueryGetRandomInnOpponentsArgs = {
  playerId: string;
  gameSubmode: string;
  numOpponents?: number;
};

const query = `
query GetRandomInnOpponents($playerId: String!, $gameSubmode: String!, $numOpponents: Int) {
  getRandomInnOpponents(playerId: $playerId, gameSubmode: $gameSubmode, numOpponents: $numOpponents) {
    gameSubmode
    innOpponents
  }
}
`;

export default async function queryGetRandomInnOpponents(
  args: QueryGetRandomInnOpponentsArgs
): Promise<RandomInnOpponentsResult> {
  return await graphqlClient.request<RandomInnOpponentsResult>(
    'getRandomInnOpponents',
    query,
    args
  );
}
